import { memo } from 'react'
import * as Styled from './styled'

import { TextWithIconTooltip } from 'common-components'
import AddIcon from 'assets/svgr-icons/Add.svg'
import { ttsThunks } from 'store/features/tts/thunks'

import { dispatch } from 'store'
import { generateRandomNumberId } from 'utils'
import { ttsSelectors } from 'store/features/tts/selectors'
import { useSelector } from 'react-redux'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { COLORS } from 'consts/colors'

interface IProps {
  setActiveTtsId?: (id: number | null) => void
}

const TtsAddButton: React.FC<IProps> = ({ setActiveTtsId }: IProps) => {
  const isDisabled = useSelector(ttsSelectors.isTtsItemsLoading)

  const handleAddButtonClick = () => {
    const draftItemId = generateRandomNumberId()
    dispatch(ttsThunks.addNewTtsDraftBlock(draftItemId))
    setActiveTtsId?.(draftItemId)
  }

  return (
    <Styled.TextToSpeechAddButtonWrapper $isDisabled={isDisabled}>
      <Styled.AddCircleButton onClick={handleAddButtonClick}>
        <TextWithIconTooltip
          tooltipText={translate(T.ADD)}
          tooltipPosition="top"
          iconProps={{
            icon: <AddIcon fill={COLORS.secondarySemiDark} />,
            customSize: 12,
            color: 'secondarySemiDark'
          }}
        />
      </Styled.AddCircleButton>
    </Styled.TextToSpeechAddButtonWrapper>
  )
}

export default memo(TtsAddButton)
